import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react'; // Assuming ArrowLeft is used for trend icons

const Statistics = ({
  totalApplications,
  statusCounts,
  summaryStats,
  trendData,
  onFilterChange,
}) => {
  console.log(summaryStats,"kkkkkllllll")
  const [filter, setFilter] = useState("all");

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    if (onFilterChange) {
      onFilterChange(newFilter);
    }
  };

  return (
    <div>
      {/* Filter dropdown */}
      <div className="flex justify-end mb-4">
        <select
          value={filter}
          onChange={(e) => handleFilterChange(e.target.value)}
          className="bg-[#1f1f1f] text-gray-300 px-3 py-2 rounded-md text-sm font-medium border border-[#333333] focus:outline-none focus:ring-2 focus:ring-[#FFCA20]"
        >
          <option value="all">All Time</option>
          <option value="yearly">Yearly</option>
          <option value="quarterly">Quarterly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="bg-[#131313] p-4 rounded">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xs uppercase">Total Applications</div>
          <svg
            width="16"
            height="20"
            viewBox="0 0 18 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.1094 4.40625C17.6719 4.96875 18 5.71875 18 6.51562V21C18 22.6875 16.6406 24 15 24H3C1.3125 24 0 22.6875 0 21V3C0 1.35938 1.3125 0 3 0H11.4844C12.2812 0 13.0312 0.328125 13.5938 0.890625L17.1094 4.40625ZM15.75 21V7.5H12C11.1562 7.5 10.5 6.84375 10.5 6V2.29688H3C2.57812 2.29688 2.25 2.625 2.25 3.04688V21C2.25 21.4219 2.57812 21.75 3 21.75H15C15.375 21.75 15.75 21.4219 15.75 21ZM4.5 13.125C4.5 12.5156 4.96875 12 5.625 12H12.375C12.9844 12 13.5 12.5156 13.5 13.125C13.5 13.7812 12.9844 14.25 12.375 14.25H5.625C4.96875 14.25 4.5 13.7812 4.5 13.125ZM12.375 16.5C12.9844 16.5 13.5 17.0156 13.5 17.625C13.5 18.2812 12.9844 18.75 12.375 18.75H5.625C4.96875 18.75 4.5 18.2812 4.5 17.625C4.5 17.0156 4.96875 16.5 5.625 16.5H12.375Z"
              fill="#FFCA20"
            />
          </svg>
        </div>
        <div className="text-3xl font-bold">{totalApplications}</div>
        <div className="flex justify-between mt-2">
          <div className="text-green-500 text-sm flex flex-col">
            <div>Approved:</div>
            <div className="font-bold text-lg">
              {statusCounts["approved"] || 0}
            </div>
          </div>
          <div className="text-red-500 text-sm">
            <div>Rejected:</div>
            <div className="font-bold text-lg">
              {statusCounts["rejected"] || 0}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#131313] p-4 rounded">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xs uppercase">Active Applications</div>
          <svg
            width="20"
            height="19"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0.5C17.7656 0.5 22.5 5.23438 22.5 11C22.5 16.8125 17.7656 21.5 12 21.5C9.51562 21.5 7.125 20.6562 5.25 19.1094C4.78125 18.6875 4.73438 17.9844 5.10938 17.5156C5.53125 17.0469 6.23438 16.9531 6.70312 17.375C8.15625 18.5938 10.0312 19.25 12 19.25C16.5469 19.25 20.25 15.5938 20.25 11C20.25 6.45312 16.5469 2.75 12 2.75C8.85938 2.75 6.04688 4.57812 4.64062 7.25H7.875C8.48438 7.25 9 7.76562 9 8.375C9 9.03125 8.48438 9.5 7.875 9.5H1.875C1.21875 9.5 0.75 9.03125 0.75 8.375V1.625C0.75 1.01562 1.21875 0.5 1.875 0.5C2.48438 0.5 3 1.01562 3 1.625V5.70312C4.82812 2.5625 8.25 0.5 12 0.5ZM12 5C12.6094 5 13.125 5.51562 13.125 6.125V11.1875L15.2344 12.7344C15.75 13.1094 15.8906 13.8125 15.5156 14.2812C15.2812 14.6094 14.9531 14.75 14.5781 14.75C14.3906 14.75 14.1562 14.7031 13.9688 14.5625L11.3438 12.6875C11.0156 12.5 10.875 12.125 10.875 11.75V6.125C10.875 5.51562 11.3438 5 12 5Z"
              fill="#FFCA20"
            />
          </svg>
        </div>
        <div className="text-3xl font-bold">
          {statusCounts["new-leads"] || 0}
        </div>
        <div className="flex justify-between mt-2">
          <div className="text-[#FFCA20] text-sm">
            <div>Submitted:</div>
            <div className="font-bold text-lg">
              {statusCounts["submitted"] || 0}
            </div>
          </div>
          <div className="text-blue-500 text-sm">
            <div>In Review:</div>
            <div className="font-bold text-lg">
              {statusCounts["in-review"] || 0}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="bg-[#131313] p-4 rounded">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xs uppercase">Customer Reviews</div>
          <svg
            width="24"
            height="21"
            viewBox="0 0 27 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.75 8.0625C25.9688 8.25 26.4844 9.75 25.5938 10.6406L20.625 15.4688L21.7969 22.2656C21.9375 23.25 21.1875 24 20.2969 24C20.0625 24 19.8281 23.9531 19.5938 23.8594L13.4531 20.625L7.35938 23.8594C7.125 23.9531 6.89062 24 6.65625 24C5.76562 24 5.01562 23.25 5.15625 22.2656L6.32812 15.4688L1.35938 10.6406C0.46875 9.75 0.984375 8.25 2.20312 8.0625L9.04688 7.07812L12.1406 0.84375C12.4219 0.28125 12.9375 0 13.4531 0C14.0156 0 14.5312 0.28125 14.8125 0.84375L17.9062 7.07812L24.75 8.0625ZM18.2812 15.0469C18.2344 14.8125 18.3281 14.5781 18.4688 14.3906L22.9219 10.0781L16.7812 9.1875C16.5469 9.14062 16.3125 9 16.2188 8.76562L13.4531 3.1875L10.7344 8.76562C10.6406 9 10.4062 9.14062 10.1719 9.1875L4.03125 10.0781L8.48438 14.3906C8.625 14.5781 8.71875 14.8125 8.67188 15.0469L7.64062 21.1406L13.125 18.2812C13.3594 18.1406 13.5938 18.1406 13.8281 18.2812L19.3125 21.1406L18.2812 15.0469Z"
              fill="#FFCA20"
            />
          </svg>
        </div>
        <div className="text-3xl font-bold">4.5/5.0</div>
        <div className="text-gray-400 text-sm mt-2">
          {filter === "all" ? "all time" : filter}
        </div>
      </div> */}

      <div className="bg-[#131313] p-4 rounded">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs uppercase text-gray-300">
            Total Revenue
          </span>
          <svg
            width="22"
            height="18"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.2344 5.4375C25.375 11.0156 24.9531 18.4219 24.9531 19.3125C24.9531 21.9375 22.6562 24 19.8438 24H6.10938C3.29688 24 1 21.9375 1 19.3125C1 18.375 0.53125 11.0625 9.67188 5.4375L7.09375 1.64062C6.90625 1.3125 6.95312 0.890625 7.14062 0.5625C7.32812 0.234375 7.70312 0 8.07812 0H17.8281C18.25 0 18.5781 0.234375 18.8125 0.5625C19 0.890625 19.0469 1.3125 18.8594 1.64062L16.2344 5.4375ZM15.7188 2.25H10.2344L12.0156 4.875H13.8906L15.7188 2.25ZM22.7031 19.3125C22.75 15.5156 21.1562 11.1094 14.7344 7.125H11.2188C4.75 11.1094 3.20312 15.5156 3.25 19.3125C3.25 20.6719 4.51562 21.75 6.10938 21.75H19.8438C21.4375 21.75 22.7031 20.6719 22.7031 19.3125Z"
              fill="#FFCA20"
            />
          </svg>
        </div>
        <div className="text-3xl font-bold text-white">
          {summaryStats?.averageProcessingTime ?? "-"} 
        </div>
        <div className="text-gray-400 text-sm mt-2">
           {filter === "all" ? "all time" : filter}
        </div>
      </div>
      {/* total loan amount */}

      <div className="bg-[#131313] p-4 rounded">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xs uppercase">total loan amount</div>
          <svg
            width="22"
            height="18"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.2344 5.4375C25.375 11.0156 24.9531 18.4219 24.9531 19.3125C24.9531 21.9375 22.6562 24 19.8438 24H6.10938C3.29688 24 1 21.9375 1 19.3125C1 18.375 0.53125 11.0625 9.67188 5.4375L7.09375 1.64062C6.90625 1.3125 6.95312 0.890625 7.14062 0.5625C7.32812 0.234375 7.70312 0 8.07812 0H17.8281C18.25 0 18.5781 0.234375 18.8125 0.5625C19 0.890625 19.0469 1.3125 18.8594 1.64062L16.2344 5.4375ZM15.7188 2.25H10.2344L12.0156 4.875H13.8906L15.7188 2.25ZM22.7031 19.3125C22.75 15.5156 21.1562 11.1094 14.7344 7.125H11.2188C4.75 11.1094 3.20312 15.5156 3.25 19.3125C3.25 20.6719 4.51562 21.75 6.10938 21.75H19.8438C21.4375 21.75 22.7031 20.6719 22.7031 19.3125Z"
              fill="#FFCA20"
            />
          </svg>
        </div>
        <div className="text-xl sm:text-2xl lg:text-3xl font-bold break-words">
          ₹{summaryStats.totalLoanAmount.toLocaleString("en-IN")}
        </div>
        <div className="text-gray-400 text-sm mt-2">
          {filter === "all" ? "all time" : filter}
        </div>
      </div>
      </div>
    </div>
  );
};

export default Statistics;
